"use strict";

import { createContext } from 'react';
export const BottomSheetInternalContext = /*#__PURE__*/createContext(null);
export const BottomSheetInternalProvider = BottomSheetInternalContext.Provider;
//# sourceMappingURL=internal.js.map